import api from './api';
import type { Medication, CreateMedicationData, UpdateMedicationData } from '../types';

export const medicationService = {
  async getMedications(): Promise<Medication[]> {
    const response = await api.get<Medication[]>('/company/medications');
    return response.data;
  },

  async getMedicationById(id: string): Promise<Medication> {
    const response = await api.get<Medication>(`/company/medications/${id}`);
    return response.data;
  },

  async createMedication(data: CreateMedicationData): Promise<Medication> {
    const response = await api.post<Medication>('/company/medications', data);
    return response.data;
  },

  async updateMedication(id: string, data: UpdateMedicationData): Promise<Medication> {
    const response = await api.patch<Medication>(`/company/medications/${id}`, data);
    return response.data;
  },

  async toggleActive(id: string, isActive: boolean): Promise<Medication> {
    const response = await api.patch<Medication>(`/company/medications/${id}`, { isActive });
    return response.data;
  },

  async deleteMedication(id: string): Promise<void> {
    await api.delete(`/company/medications/${id}`);
  },

  async uploadPhoto(id: string, file: File): Promise<string> {
    const formData = new FormData();
    formData.append('photo', file);

    const response = await api.post<{ url: string }>(`/company/medications/${id}/photo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data.url;
  },
};
